// extracted by mini-css-extract-plugin
export default {"grid":"WebinarList_grid__2Z0Pe","btn":"WebinarList_btn__79Ijm","btnLink":"WebinarList_btnLink__iaU75"};